<template>
  <transition
    name="height"
    @before-enter="beforeEnterAndLeave"
    @enter="enterAndBeforeLeave"
    @before-leave="enterAndBeforeLeave"
    @leave="beforeEnterAndLeave"
  >
    <slot />
  </transition>
</template>

<script setup lang="ts">
import { useSlots, nextTick, watch } from 'vue';
import { useWindowSize } from '@vueuse/core';

const slots = useSlots();
const { width } = useWindowSize();

const beforeEnterAndLeave = (el: HTMLElement) => el.style.height = '0';
const enterAndBeforeLeave = (el: HTMLElement) => el.style.height = `${ el.scrollHeight }px`;

const updateHeight = async () => {
  if (slots.default) {
    const vnodes = slots.default();
    if (vnodes.length === 0) return;

    await nextTick();
    const el = vnodes[0].elm as HTMLElement | null;
    if (el) {
      el.style.height = `${el.scrollHeight}px`;
    }
  }
};

watch(width, updateHeight);
</script>

<style lang="scss" scoped>
.height-enter-active, .height-leave-active {
  transition: height 0.15s ease;
  overflow: hidden;
  will-change: height;
}
</style>
